import { Component } from "react";

// Screen-level guard: a crash inside one screen renders a scoped fallback
// instead of unmounting the whole shell (no more blank #root pages).
export default class ScreenBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="screen-error" className="px-6 py-16 lg:px-12" role="alert">
          <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-os-red">Something broke on this page</p>
          <h1 className="mt-2 text-[16px] font-semibold tracking-[-0.01em] text-os-ink">
            This screen hit an error and couldn't render
          </h1>
          <p className="mt-2 max-w-xl text-[13px] leading-[1.55] text-os-ink-2">
            Everything else is fine — navigation still works. Kit has the error details and is on it.
          </p>
          <button
            type="button"
            data-testid="screen-error-retry"
            onClick={() => this.setState({ error: null })}
            className="mt-6 inline-flex h-9 items-center rounded-control border border-os-border bg-white px-4 font-mono text-[12px] text-os-ink hover:border-os-border-strong"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}